import { render, staticRenderFns } from "./AdsorptionForce.vue?vue&type=template&id=637b4f27&scoped=true"
import script from "./AdsorptionForce.vue?vue&type=script&lang=js"
export * from "./AdsorptionForce.vue?vue&type=script&lang=js"
import style0 from "./AdsorptionForce.vue?vue&type=style&index=0&id=637b4f27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637b4f27",
  null
  
)

export default component.exports